import {Component, Input, OnInit} from '@angular/core';
import {NgbDate, NgbDatepickerConfig, NgbDateStruct, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute, Router} from '@angular/router';
import {CommonComponent} from '../../shared/common/common.component';
import {NotificationsService} from '../../../services/notifications.service';
import {IReferral} from '../../../domain/onBoarding/IReferral';
import {Application} from '../../../domain/onBoarding/application';
import {ApplicationService} from '../../../services/application.service';
import {CatalogsService} from '../../../services/catalogs.service';
import {ICountry} from '../../../domain/ICountry';
import {ECatalog} from '../../../enums/ECatalog';
import {NgForm} from '@angular/forms';
import {AccountService} from '../../../services/account.service';
import {CustomerDetail} from '../../../domain/customer/customer-detail';
import {Account} from '../../../domain/accounts/account';
import {ApplicationBody, ApplicationStatus} from '../../../domain/onBoarding/application-body';
import {ApplicationEntity} from '../../../entity/ApplicationEntity';
import {ToastaService} from 'ngx-toasta';
import {IGeneric} from '../../../domain/IGeneric';
import {TranslateService} from '@ngx-translate/core';
import {DialogService} from 'primeng/dynamicdialog';
import {ConfigurationService} from '../../../services/configuration.service';

@Component({
  selector: 'app-referred',
  templateUrl: './referred.component.html',
  styleUrls: ['./referred.component.scss']
})
export class ReferredComponent extends CommonComponent implements OnInit {
  hasReferralValue = false;
  hasAccount: boolean = null;
  forms: boolean = null;
  minDate: NgbDate = new NgbDate(1920, 1, 1);
  referred: IReferral = {};
  application: Application;
  countryWhereYouLive: ICountry[] = null;
  referredRelationship: IGeneric[];
  uglyReferredBirthdate: NgbDateStruct;
  customerDetail: CustomerDetail;
  activeAccount: Account;

  constructor(
    protected router: Router,
    private activatedRoute: ActivatedRoute,
    private catalogsService: CatalogsService,
    private applicationService: ApplicationService,
    private accountsService: AccountService,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    configCalendar: NgbDatepickerConfig,
    protected toastService: ToastaService,
    public translate: TranslateService,
    protected dialogService: DialogService,
    public configurationService: ConfigurationService
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    configCalendar.minDate = this.minDate;
    this.application = this.applicationService.application;
  }

  ngOnInit(): void {
    if (!this.application || !this.application.editing) {
      this.router.navigate(['/onboarding/']);
      return;
    }
    this.application.body.referrals = [];
    this.hasReferralValue = this.application.body.referrals.length > 0;
    if (this.applicationService.application.body.referrals === null) {
      this.application.body.referrals = [];
    }
    this.getCountriesCatalog();
    this.getReferrerRelationships();
  }

  onSubmit() {
    this.loadingModalOn();
    const referred = this.applicationService.application.body.referrals;
    if (this.hasReferralValue) {
      if (referred.length === 0) {
        this.loadingModalOff();
        this.msgWarning(this.translate.instant('onboarding.referred.warning-one', {Default: 'Debe de agregar al menos un referido antes de continuar'}));
        return false;
      }
    }
    let submit = false;
    if ((this.application.body.socialSecurityNumber !== null && this.application.body.socialSecurityNumber !== '') || (this.application.body.driverLicenseNumber !== null && this.application.body.driverLicenseNumber !== '')) {
      submit = true;
    }
    this.applicationService.setApplication(submit).subscribe(
      (response: ApplicationBody) => {
        this.application.body.cipQuestions = response.cipQuestions;
        this.loadingModalOff();
        if ((this.application.body.socialSecurityNumber == null || this.application.body.socialSecurityNumber == '') && (this.application.body.driverLicenseNumber == null || this.application.body.driverLicenseNumber == '')) {
          this.router.navigate(['/onboarding/additionalIdentification']);
        } else {
          switch (response.status) {
            case ApplicationStatus.APPROVED:
            case ApplicationStatus.SUBMITTED:
              this.msgSuccess(
                this.translate.instant('onboarding.referred.registerTitle', {Default: '¡Gracias hemos recibido tu solicitud!'}),
                this.translate.instant('onboarding.referred.registerMessage', {Default: 'Se va a revisar tu información, en cuanto todo quede listo en tu correo registrado recibirás tus contratos y podrás hacer login en tu aplicación.'}));
              this.router.navigate(['/']);
              break;
            case ApplicationStatus.BLACK_LIST_DOCUMENTS:
              this.router.navigate(['/onboarding/photos']);
              break;
            case ApplicationStatus.BLACK_LIST_QUESTIONS:
              this.router.navigate(['/onboarding/additionalQuestions']);
              break;
            default:
              this.msgError(this.translate.instant('onboarding.referred.error-try-again', {Default: 'Hubo un problema al generar su aplicación, por favor vuelva a intentarlo'}));
          }
        }
      },
      error => {
        this.loadingModalOff();
        this.msgError(error);
        if (error.error.code === '4600') {
          this.applicationService.application = new ApplicationEntity();
          this.router.navigate(['/']);
        }
      }
    );
  }

  onSubmit_newAccount(form: NgForm): void {
    if (this.referred.referrerIdRelationship != 6) {
      this.referred.referrerRelationship = null;
    }
    this.application.body.referrals.push(this.referred);
    this.referred = {};
    this.uglyReferredBirthdate = null;
    this.hasReferralValue = false;
  }

  getCountriesCatalog() {
    this.catalogsService.getCatalog(ECatalog.COUNTRY).subscribe(
      (response: any) => {
        this.countryWhereYouLive = response;
      }, error => {
        this.msgError(error);
      }
    );
  }

  onBack() {
    this.router.navigate(['/onboarding/contracts']);
  }

  onReferredBirthdateChange() {
    this.referred.dateOfBirth = this.formatDate(this.uglyReferredBirthdate);
  }

  cancel(form: NgForm) {
    this.hasReferralValue = false;
    form.resetForm();
  }

  getReferrerRelationships() {
    this.catalogsService.getCatalog(ECatalog.REFERRER_RELATIONSHIP).subscribe(
      (response: any) => {
        this.referredRelationship = response;
      }, error => {
        this.msgError(error);
      }
    );
  }

}
